import { useMemo } from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

export function useTextData(props: QRProps<"text">) {
  const { data, isInitPreview } = usePreviewData(props, {
    prioritizeContext: props.preview === true && !props.initPreview,
  });

  const message = useMemo(() => {
    return data?.message ?? "";
  }, [data?.message]);

  return {
    message,
    isInitPreview,
  };
}
